import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { useTranslation } from "react-i18next";
import { generatePageNumbers } from "utils/generatePageNumbers";

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  isLoading,
}) => {
  const { t } = useTranslation("common");
  if (totalPages <= 1) return null;

  const handlePageClick = (e, page) => {
    e.preventDefault();
    if (
      page !== "..." &&
      page >= 1 &&
      page <= totalPages &&
      page !== currentPage
    ) {
      onPageChange(page);
    }
  };

  return (
    <nav aria-label={t("pagination.navigation")}>
      <Pagination listClassName="mb-0">
        <PaginationItem
          className="mb-0"
          disabled={isLoading || currentPage === 1}
        >
          <PaginationLink
            aria-label={t("pagination.previous")}
            href="#pablo"
            onClick={(e) => handlePageClick(e, currentPage - 1)}
          >
            <span aria-hidden={true}>
              <i className="tim-icons icon-double-left" />
            </span>
          </PaginationLink>
        </PaginationItem>

        {generatePageNumbers(currentPage, totalPages).map((page, index) => (
          <PaginationItem
            key={index}
            active={currentPage === page}
            className={currentPage === page ? "active" : ""}
            disabled={page === "..." || isLoading}
          >
            <PaginationLink
              href="#pablo"
              onClick={(e) => handlePageClick(e, page)}
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}

        {/* Next Button */}
        <PaginationItem disabled={isLoading || currentPage === totalPages}>
          <PaginationLink
            aria-label={t("pagination.next")}
            href="#pablo"
            onClick={(e) => handlePageClick(e, currentPage + 1)}
          >
            <span aria-hidden={true}>
              <i className="tim-icons icon-double-right" />
            </span>
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </nav>
  );
};

export default CustomPagination;
